import { MotionConfig } from 'motion/react'
import Nav from '../components/landing/Nav'
import Hero from '../components/landing/Hero'
import TransformSection from '../components/landing/transform/TransformSection'
import ProductProof from '../components/landing/ProductProof'
import HowItWorks from '../components/landing/HowItWorks'
import Privacy from '../components/landing/Privacy'
import Faq from '../components/landing/Faq'
import CtaBand from '../components/landing/CtaBand'
import Footer from '../components/landing/Footer'

export default function LandingPage() {
  return (
    // `reducedMotion="user"` makes every Motion animation below this point
    // honour prefers-reduced-motion without each section having to remember.
    // The section-entrance animations use `whileInView` with shared variants
    // and would otherwise run regardless of the setting — only the hero and
    // the transform canvas handle it explicitly.
    <MotionConfig reducedMotion="user">
      <div className="landing-root relative isolate min-h-screen bg-surface-base text-white">
        {/* The wash lives here rather than on the hero so it runs behind the
            nav too. On the hero it started below the sticky header, leaving a
            hard seam across the top that read as a black bar.
            `isolate` keeps the -z-10 layer above this div's own background
            instead of escaping behind it. */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[56rem] bg-mesh-hero"
        />
        <Nav />
        <main>
          <Hero />
          <TransformSection />
          <ProductProof />
          <HowItWorks />
          <Privacy />
          <Faq />
          <CtaBand />
        </main>
        <Footer />
      </div>
    </MotionConfig>
  )
}
